import type { ButtonProps } from './Button.types'
import { Spinner } from '@/components/Spinner'

export function Button({
    variant = 'primary',
    isLoading = false,
    className = '',
    children,
    ...props
}: ButtonProps) {
    const baseStyles =
        'px-4 py-2 rounded-xl font-medium transition-all duration-200 flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed'
    const variants = {
        primary: 'bg-primary text-white hover:bg-primary/90 shadow-lg shadow-primary/20',
        secondary:
            'bg-surface-light dark:bg-surface-dark text-text-primary-light dark:text-text-primary-dark border border-border-light dark:border-border-dark hover:bg-border-light/30 dark:hover:bg-white/5',
        outline: 'border-2 border-primary text-primary hover:bg-primary/10',
    }

    return (
        <button
            className={`${baseStyles} ${variants[variant]} ${className}`}
            disabled={isLoading || props.disabled}
            {...props}
        >
            {isLoading ? <Spinner size="sm" /> : children}
        </button>
    )
}
